import { HashRouter as Router } from 'react-router'
import AppVersionWatcher from './components/common/AppVersionWatcher'
import { FullScreenProvider } from './contexts/FullScreenContext'
import { SidebarProvider } from './contexts/SidebarContext'
import SnackbarProvider from './contexts/SnackbarProvider'
import AppRoutes from './routes/AppRoutes'

import { Provider } from 'react-redux'
import store from './store'

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppVersionWatcher />
        <SnackbarProvider>
          <SidebarProvider>
            <FullScreenProvider>
              <AppRoutes />
            </FullScreenProvider>
          </SidebarProvider>
        </SnackbarProvider>
      </Router>
    </Provider>
  )
}

export default App
